"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var Styled = _interopRequireWildcard(require("./styles/IconForward.style"));
var _ruleSet = require("../../ruleSet");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var IconForward = function IconForward(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.39 11.926V12c-.042.406-.218.79-.492 1.09l-1.238 1.285-2.687 2.8a.82.82 0 0 1-1.407-.562v-.488a.754.754 0 0 0 0-.133c-.062-.492-.398-.828-1-.867-2.75-.184-5.613.25-8.027 1.625-.418.234-.828.496-1.25.734a.5.5 0 0 1-.726-.597c.949-2.801 2.445-4.676 4.035-5.926 2.16-1.7 4.488-2.211 5.843-2.254.485-.012 1.02-.36 1.11-.832a1.73 1.73 0 0 0 .023-.2v-.448a.794.794 0 0 1 .781-.817h.055a.8.8 0 0 1 .567.25l2.043 2.074 1.886 1.91.074.086c.22.278.36.61.403.961.008.079.012.157.008.235Zm0 0",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};
IconForward.displayName = "IconForward";
var _default = IconForward;
exports["default"] = _default;